export default "__VITE_ASSET__C9vc5iw5__"